/** Canonical presentation projection returned by the identity.me MCP tool. */
export interface IdentityMe {
  ok: boolean;
  error?: string;
  identity?: {
    id: string;
    label: string;
    type: string;
    class: string | null;
    avatar_url: string | null;
    locale: string | null;
    tenant_id: string | null;
  };
  session?: { kind: 'keycloak' | 'local' | 'api_key' };
  capabilities?: {
    is_admin: boolean;
    all_modules: boolean;
    platform?: boolean;
    role?: string | null;
    modules: string[];
  };
}

export const IDENTITY_ME_QUERY_KEY = ['identity-me'] as const;

export function identityEntityId(me: IdentityMe | undefined): string | undefined {
  return me?.ok ? me.identity?.id : undefined;
}
